// Appointment status enum — single source of truth for status keys, used by the
// appointments calendar/badges and the Daily Checkout Report appointment colors.
export const APPOINTMENT_STATUS = {
  SCHEDULED: "SCHEDULED",
  RESCHEDULED: "RESCHEDULED",
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
  SHOWED: "SHOWED",
  NO_SHOWED: "NO_SHOWED",
};

// Per-status colors (bg fill, border/accent, text for calendar/badges; `checkout`
// for the Daily Checkout Report breakdown) — single source of truth.
export const APPOINTMENT_STATUS_COLORS = {
  [APPOINTMENT_STATUS.SCHEDULED]: {
    bg: "#BAE0FF",
    border: "#1677FF",
    text: "#0958d9",
    checkout: "#9254DE",
  },
  [APPOINTMENT_STATUS.RESCHEDULED]: {
    bg: "#EFDBFF",
    border: "#722ED1",
    text: "#531dab",
    checkout: "#597EF7",
  },
  [APPOINTMENT_STATUS.CONFIRMED]: {
    bg: "#B5F5EC",
    border: "#13C2C2",
    text: "#08979c",
    checkout: "#36CFC9",
  },
  [APPOINTMENT_STATUS.CANCELLED]: {
    bg: "#FFCCC7",
    border: "#F5222D",
    text: "#cf1322",
    checkout: "#D9D9D9",
  },
  [APPOINTMENT_STATUS.SHOWED]: {
    bg: "#A7F2CF",
    border: "#52C41A",
    text: "#389e0d",
    checkout: "#73D13D",
  },
  [APPOINTMENT_STATUS.NO_SHOWED]: {
    bg: "#D9D9D9",
    border: "#595959",
    text: "#595959",
    checkout: "#FFC53D",
  },
};
